// social media
export const MAVRYK_GITHUB_URL = 'https://github.com/mavrykdynamics';
export const MAVRYK_TWITTER_URL = 'https://x.com/MavrykDynamics';
export const MAVRYK_LINKEDIN_URL =
  'https://www.linkedin.com/company/mavryk-dynamics/';

// uncomment sections to test flexibility
export const socialMedias = [
  { name: 'twitter', link: MAVRYK_TWITTER_URL },
  { name: 'linkedin', link: MAVRYK_LINKEDIN_URL },
  { name: 'github', link: MAVRYK_GITHUB_URL },
];
